import React, { useMemo } from 'react';
import { Button, TableProps } from 'antd';
import { PaymentAccount } from '~/types/payment';

export const useColumns = ({
  openDrawer,
}: {
  openDrawer: (item?: PaymentAccount) => void;
}) => {
  return useMemo((): TableProps<PaymentAccount>['columns'] => {
    return [
      {
        title: 'Account Code',
        dataIndex: 'accountCode',
      },
      {
        title: 'Account Name',
        dataIndex: 'accountName',
      },
      {
        title: 'Account No.',
        dataIndex: 'accountNumber',
      },
      {
        title: 'Rotation Count',
        dataIndex: 'rotationCount',
      },
      {
        title: 'Order',
        dataIndex: 'sequence',
      },
      {
        title: 'Action',
        render: (_, item) => {
          return (
            <div>
              <Button type="primary" onClick={() => openDrawer(item)}>
                Edit
              </Button>
            </div>
          );
        },
      },
    ];
  }, [openDrawer]);
};
